import register from 'preact-custom-element'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { useEffect, useState } from 'preact/hooks'
import { on, select } from 'helpers/dom'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

const selector = {
  DIMENSION_IMAGE_WRAPPER_SELECTOR: '.js-dimension-image-wrapper',
  IMAGE_MODAL_DIALOG_SELECTOR: '.js-dimension-image-zoom'
}

function ProductDescriptionLinked({ title }) {
  const [swatches, setSwatches] = useState([])

  useEffect(() => {
    globalEmitter.on(emitterProps.product.productLinked, (value) => {
      setSwatches(value)
    })
  })

  return (
    swatches?.length > 0 && (
      <div className="mb-4 px-3 py-4">
        <div className="mb-2 font-sans text-sm font-medium text-black">{title}</div>
        <div className="flex flex-wrap gap-4">
          {swatches.map((swatch) => (
            <div className="flex items-center gap-2">
              <span className={`h-8 w-8 rounded-full ${swatch.color.hex === '#ffffff' ? 'border' : ''}`} style={`background-color: ${swatch.color.hex}`}></span>
              <span>{swatch.prettyColorName ?? swatch.color.name}</span>
            </div>
          ))}
        </div>
      </div>
    )
  )
}

class ProductDimensions extends HTMLElement {
  constructor() {
    super()
    this.imageWrapperEl = select(selector.DIMENSION_IMAGE_WRAPPER_SELECTOR, this)
    this.modalEl = select(selector.IMAGE_MODAL_DIALOG_SELECTOR)
  }

  connectedCallback() {
    if (this.imageWrapperEl) {
      on('click', () => {
        this.modalEl.show()
      }, this.imageWrapperEl)
    }
  }
}

register(ProductDescriptionLinked, 'product-description-linked', ['title'])
if (!customElements.get('product-dimensions')) {
  customElements.define('product-dimensions', ProductDimensions)
}
